"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSurveyQuestionStatusesRequestToJSON = exports.UpdateSurveyQuestionStatusesRequestFromJSONTyped = exports.UpdateSurveyQuestionStatusesRequestFromJSON = exports.instanceOfUpdateSurveyQuestionStatusesRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateSurveyQuestionStatusesRequest interface.
 */
function instanceOfUpdateSurveyQuestionStatusesRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateSurveyQuestionStatusesRequest = instanceOfUpdateSurveyQuestionStatusesRequest;
function UpdateSurveyQuestionStatusesRequestFromJSON(json) {
    return UpdateSurveyQuestionStatusesRequestFromJSONTyped(json, false);
}
exports.UpdateSurveyQuestionStatusesRequestFromJSON = UpdateSurveyQuestionStatusesRequestFromJSON;
function UpdateSurveyQuestionStatusesRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adSetControlId': !(0, runtime_1.exists)(json, 'ad_set_control_id') ? undefined : json['ad_set_control_id'],
        'adSetExposedId': !(0, runtime_1.exists)(json, 'ad_set_exposed_id') ? undefined : json['ad_set_exposed_id'],
        'isAdSetControlMapped': !(0, runtime_1.exists)(json, 'is_ad_set_control_mapped') ? undefined : json['is_ad_set_control_mapped'],
        'isAdSetExposedMapped': !(0, runtime_1.exists)(json, 'is_ad_set_exposed_mapped') ? undefined : json['is_ad_set_exposed_mapped'],
        'creativeExposedId': !(0, runtime_1.exists)(json, 'creative_exposed_id') ? undefined : json['creative_exposed_id'],
        'creativeControlId': !(0, runtime_1.exists)(json, 'creative_control_id') ? undefined : json['creative_control_id'],
        'assetId': !(0, runtime_1.exists)(json, 'asset_id') ? undefined : json['asset_id'],
    };
}
exports.UpdateSurveyQuestionStatusesRequestFromJSONTyped = UpdateSurveyQuestionStatusesRequestFromJSONTyped;
function UpdateSurveyQuestionStatusesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_set_control_id': value.adSetControlId,
        'ad_set_exposed_id': value.adSetExposedId,
        'is_ad_set_control_mapped': value.isAdSetControlMapped,
        'is_ad_set_exposed_mapped': value.isAdSetExposedMapped,
        'creative_exposed_id': value.creativeExposedId,
        'creative_control_id': value.creativeControlId,
        'asset_id': value.assetId,
    };
}
exports.UpdateSurveyQuestionStatusesRequestToJSON = UpdateSurveyQuestionStatusesRequestToJSON;
